import CartApiService from '@package/core/src/shoppingCart/CartApiService';
import CartInteractor from '@package/core/src/shoppingCart/CartInteractor';
import { AddMissingItemRequest, GetServiceInfoRequest } from '@package/core/src/shoppingCart/interactorTypes';

import { apiClient, cookieStorage, listrakAnalytic } from '../services';
import { useQueryClient, useStrictMutation, useStrictQuery } from '../useCustomQuery';
import { SHOPPING_CART_DATA_QUERY_KEY } from '../useShoppingCart/types';

import { SERVICE_INFO_QUERY_KEY } from './types';

const cartService = new CartApiService(apiClient, cookieStorage, listrakAnalytic);
const cartInteractor = new CartInteractor(cartService);

export default function useServiceMissingItem(request: GetServiceInfoRequest) {
  const queryClient = useQueryClient();

  const { data: serviceInfo, isFetching } = useStrictQuery(
    [SERVICE_INFO_QUERY_KEY, request.serviceId, request.relatedProductSku],
    async () => {
      const res = await cartInteractor.getServiceInfo(request);

      return res.data;
    },
  );

  const { mutateAsync: addMissingItem } = useStrictMutation(
    async (data: AddMissingItemRequest) => {
      await cartInteractor.addMissingItem(data);
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries([SHOPPING_CART_DATA_QUERY_KEY]);
      },
    },
  );

  return { serviceInfo, addMissingItem, isFetching };
}
